import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";


const ClosingStockModal = ({ showStockModal, closeStockModal, branch, itemCode, onSelectItem }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch stock details from API
  const fetchData = async () => {
    if (!branch || !itemCode) return;
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/stockSummary_closingStock", {
        params: { branch, code: itemCode },
      });


      setSearchResults(response.data.results || []);
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showStockModal) {
      fetchData();
    }
  }, [showStockModal, branch, itemCode]);

  const handleSelectItem = (item) => {
    if (onSelectItem) {
      onSelectItem(item);
    }
    closeStockModal();
  };

  if (!showStockModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">Closing Stock Details</h3>
        <h3 className="modal-title">Selected Item Code : {itemCode}</h3>

        {loading ? (
          <p className="loading-text">Loading...</p>
        ) : (
          <div className="search-results">
            <table>
              <thead>
                <tr>
                  <th>Branch Code</th>
                  <th>Closing Stock</th>
                  <th>Serial Numbers</th>
                </tr>
              </thead>
              <tbody>
  {searchResults.length > 0 ? (
    <>
      {searchResults.map((item, index) => (
        <tr key={index}>
          <td>{item.branchCode}</td>
          <td>{item.closingStock}</td>
          <td>{item.serialNumbers}</td>
        </tr>
      ))}
      {/* Total Stock Row */}
      <tr className="total-stock-row">
  <td><strong>Total Stock:</strong></td>
  <td colSpan="1">
    <strong>
      {new Intl.NumberFormat("en-IN").format(
        searchResults.reduce((sum, item) => sum + Number(item.closingStock || 0), 0)
      )}
    </strong>
  </td>
</tr>

    </>
  ) : (
    <tr>
      <td colSpan="4" className="no-results">No results found</td>
    </tr>
  )}
</tbody>

            </table>
          </div>
        )}

        <button className="close-btn" onClick={closeStockModal}>Close</button>
      </div>
    </div>
  );
};

export default ClosingStockModal;
